import React, { memo, useContext } from 'react'
import { Button } from '../index'
import PropTypes from 'prop-types'
import { LanguageContext } from '../../../context/LanguageContext'

const BulkEdit = ({ clearSelection, selectAll, children }) => {
    const { strings, formatString } = useContext(LanguageContext)

    return (
        <div className={'bulk-edit'}>
            <div className={'bulk-edit__records'}>
                {formatString('ITEMS_SELECTED', {
                    SELECTED: selectAll.length,
                })}
            </div>
            <div className={'bulk-edit__actions'}>
                <Button
                    className={'clear mt-0 mb-0'}
                    color={'transparent'}
                    onClick={clearSelection}
                >
                    {strings.CLEAR}
                </Button>
                {children}
            </div>
        </div>
    )
}

BulkEdit.propTypes = {
    /** @param clearSelection {CallableFunction} -> Callback to clear the selected records. */
    clearSelection: PropTypes.func,

    /** @param selectAll {array} -> Array(Object) of records selected */
    selectAll: PropTypes.arrayOf(PropTypes.object),

    /** @param children {JSX} renders the JSX wrapped in between BulkEdit Component */
    children: PropTypes.element,
}

export default memo(BulkEdit)
